import { render, staticRenderFns } from "./frozenassets.vue?vue&type=template&id=d42cea94"
import script from "./frozenassets.vue?vue&type=script&lang=js"
export * from "./frozenassets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports